import React from "react";
import { Link } from "react-router-dom";

import emailIcon from "../../../../assets/images/email-icon.svg";
import styles from "./ConfirmationPage.scss";

class ConfirmationPage extends React.Component {
  render() {
    return (
      <section>
        <section className={styles.confirmationPage}>
          <div className={styles.content}>
            <h2 className={styles.title}>On its way!</h2>

            <div className={styles.form}>
              <img
                src={emailIcon}
                alt="Letter"
                className={styles.envelopeIcon}
              />

              <div className={styles.subtitle}>
                Check your email for a link to reset your password.
              </div>

              <div className={styles.subtitle}>
                <span>
                  <Link to="/log-in">Go back to the login screen</Link>
                </span>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./src/routes/common/confirmationPage/components/ConfirmationPage.js